module.exports = __webpack_public_path__ + "img/org1.4c790375.png";